import React from 'react';

export function ImageWithFallback(props) {
  const { src, alt, style, className, fetchPriority, decoding, fallback, ...rest } = props;
  const [currentSrc, setCurrentSrc] = React.useState(src);
  const [didError, setDidError] = React.useState(false);
  const [triedAlternative, setTriedAlternative] = React.useState(false);

  React.useEffect(() => {
    setCurrentSrc(src);
    setDidError(false);
    setTriedAlternative(false);
  }, [src]);

  const handleError = () => {
    if (!triedAlternative && typeof currentSrc === 'string') {
      setTriedAlternative(true);
      if (currentSrc.includes('/developers/')) {
        setCurrentSrc(currentSrc.replace('/developers/', '/Developers/'));
        return;
      } else if (currentSrc.includes('/Developers/')) {
        setCurrentSrc(currentSrc.replace('/Developers/', '/developers/'));
        return;
      }
    }
    setDidError(true);
  };

  const getResolvedSrc = (url) => {
    if (!url) return '';
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:') || url.startsWith('blob:')) {
      return url;
    }
    const publicUrl = process.env.PUBLIC_URL || '';
    if (publicUrl && url.startsWith('/') && !url.startsWith(publicUrl)) {
      return `${publicUrl}${url}`;
    }
    return url;
  };

  const imgProps = {
    ...rest,
    ...(fetchPriority && { fetchpriority: fetchPriority }),
    ...(decoding && { decoding })
  };

  const resolved = getResolvedSrc(currentSrc);

  if (didError || !resolved) {
    if (fallback) return fallback;
    return (
      <div
        className={`flex items-center justify-center bg-gradient-to-br from-amber-100 to-amber-200 text-amber-900 ${className ?? ''}`}
        style={style}
        title={alt || 'Team Member'}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="w-1/2 h-1/2 text-amber-700/60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/>
          <circle cx="12" cy="7" r="4"/>
        </svg>
      </div>
    );
  }

  return (
    <img
      src={resolved}
      alt={alt}
      loading="lazy"
      decoding="async"
      className={className}
      style={style}
      {...imgProps}
      onError={handleError}
    />
  );
}

